import React from 'react'
import PropTypes from 'prop-types'
import { CompanyModal } from './company-modal'
import { BaseCompanyModal } from './base-company-modal'
import { ConfirmBox } from '../confirm-box/confirm'
import { Table } from '@advanced/component-mosaic-table'
import { inject, observer } from 'mobx-react'
import { SessionStore } from '../../stores'
import { schema } from './schema'
import { publish } from '../../utils/pubsub'
import { Placeholder } from '../placeholder'

@inject('sessionStore')
@observer
class Companies extends React.Component {
  constructor (props) {
    super(props)
    this.table = null
    this.tableRef = React.createRef()
    this.state = {
      ready: false,
      companies: [],
      deleteCompanyData: false,
      deleteCompanyShowConfirm: false,
      companyEntryShowModal: false,
      companyEntryData: {
        data: {
          id: null,
          name: '',
          sourceReference: '',
          numberImportParts: 1,
          numberGLElements: 0,
          isCompanyActive: false,
          active: false,
          ImportParts: [
            {
              importPart: '',
              type: 'basic',
              active: false
            }
          ],
          GLElements: [
            {
              glNumber: 1,
              label: '',
              numberCharacters: 1
            }
          ]
        }
      },
      companyEntryHeader: null,
      companyAction: null
    }
    this.toggleCompanyEntry = this.toggleCompanyEntry.bind(this)
    this.cancelCompanyEntry = this.cancelCompanyEntry.bind(this)
    this.addCompany = this.addCompany.bind(this)
    this.toggleDeleteCompanyCancel = this.toggleDeleteCompanyCancel.bind(this)
    this.toggleDeleteCompanyConfirm = this.toggleDeleteCompanyConfirm.bind(this)
    this.deleteCompanyConfirmed = this.deleteCompanyConfirmed.bind(this)
    this.saveCompany = this.saveCompany.bind(this)
    this.companyModalRef = React.createRef()
    this.companyDeleteMessage = ''
  }

  /* company entry methods */

  toggleCompanyEntry () {
    this.setState({
      companyEntryShowModal: !this.state.companyEntryShowModal
    })
  }

  cancelCompanyEntry () {
    this.setState({
      companyEntryShowModal: false,
      companyEntryData: {
        table: this.table,
        data: {
          id: null,
          name: '',
          sourceReference: '',
          isCompanyActive: false,
          numberImportParts: 1,
          numberGLElements: 0,
          ImportParts: [
            {
              importPart: '',
              type: 'basic',
              active: false
            }
          ],
          GLElements: [
            {
              glNumber: 1,
              label: '',
              numberCharacters: 1
            }
          ]
        },
        index: -1
      }
    })
  }

  addCompany () {
    this.setState({
      companyEntryData: {
        table: this.table,
        data: {
          id: null,
          name: '',
          sourceReference: '',
          isCompanyActive: false,
          numberImportParts: 1,
          numberGLElements: 0,
          ImportParts: [
            {
              importPart: '',
              type: 'basic',
              active: false
            }
          ],
          GLElements: [
            {
              glNumber: 1,
              label: '',
              numberCharacters: 1
            }
          ]
        },
        index: -1
      },
      companyEntryShowModal: true,
      companyEntryHeader: 'Add company',
      companyActionButtonName: 'Save',
      companyAction: 'add'
    }, () => {
      this.companyModalRef.current.show()
    })
  }

  /* delete company methods */

  toggleDeleteCompanyCancel () {
    this.setState({
      deleteCompanyShowConfirm: false
    })
  }

  toggleDeleteCompanyConfirm () {
    this.setState({
      deleteCompanyShowConfirm: !this.state.deleteCompanyShowConfirm
    })
  }

  deleteCompanyConfirmed () {
    this.setState(() => ({
      companies: this.state.companies.filter((item, i) => item.name !== this.state.deleteCompanyData.data.name &&
      item.sourceReference !== this.state.deleteCompanyData.data.sourceReference),
      deleteCompanyShowConfirm: false
    }), () => {
      this.table.removeRow(this.state.deleteCompanyData.index)
      this.triggerOnChange()
    })
  }

  /* save company */
  // saveCompany (name, sourceReference)
  saveCompany (name, sourceReference, isCompanyActive, numberImportParts, numberGLElements, ImportParts, glElements) {
    const companyEntryData = { ...this.state.companyEntryData }
    if (this.props.sessionStore.isFullEdition) {
      companyEntryData.data['numberImportParts'] = numberImportParts
      companyEntryData.data['numberGLElements'] = numberGLElements
      companyEntryData.data['ImportParts'] = ImportParts
      companyEntryData.data['GLElements'] = glElements
    }
    companyEntryData.data['name'] = name
    companyEntryData.data['sourceReference'] = sourceReference
    companyEntryData.data['active'] = isCompanyActive

    const companies = [...this.state.companies]
    if (this.state.companyEntryData.index > -1) {
      companies[this.state.companyEntryData.index] = companyEntryData.data
    } else {
      companies.push(companyEntryData.data)
    }
    this.setState(() => ({
      companies
    }), () => {
      if (this.state.companyEntryData.index > -1) {
        this.table.setRowData(this.state.companyEntryData.index, companyEntryData.data)
      } else {
        this.table.addRow(companyEntryData.data)
      }
      this.triggerOnChange()
    })
  }

  /* table methods */

  initialiseCompaniesTable () {
    if (!this.table) {
      const data = () => this.state.companies.slice()
      const onAction = (table, action, [{ index, rowData, value }]) => this.onCompaniesTableAction(table, action, [{ index, rowData, value }])
      this.table = new Table(this.tableRef.current, {
        bordered: true,
        small: true,
        headClassName: 'bg-light',
        schema,
        data,
        totalCount: this.state.companies.length,
        onAction
      })
    }
  }

  onCompaniesTableAction (table, action, rowDetails) {
    if (action === 'editAction') {
      if (rowDetails[0].rowData.ImportParts.length === 0) {
        rowDetails[0].rowData.ImportParts = [
          {
            importPart: '',
            type: 'basic',
            active: false
          }
        ]
        rowDetails[0].rowData.numberImportParts = 1
      }
      if (rowDetails[0].rowData.GLElements.length === 0) {
        rowDetails[0].rowData.GLElements = [
          {
            glNumber: 1,
            label: '',
            numberCharacters: 1
          }
        ]
        rowDetails[0].rowData.numberGLElements = 0
      }

      this.editCompany(table, rowDetails[0].rowData, rowDetails[0].index)
    } else if (action === 'deleteAction') {
      this.deleteCompany(table, rowDetails[0].rowData, rowDetails[0].index)
    }
  }

  editCompany (table, data, index) {
    this.setState({
      companyEntryData: { table, data, index },
      companyEntryHeader: 'Edit company',
      companyActionButtonName: 'Confirm Changes',
      companyAction: 'edit'
    }, () => { this.companyModalRef.current.show() })
  }

  deleteCompany (table, data, index) {
    const baseEditionMsg = 'Do you want to delete this company?'
    const fullEditionMsg = `By deleting the company, all the associated adjustment and journals details, if any, will be removed.
    \nDo you still want to delete the company?`

    if (this.state.companies.length === 1) {
      publish('toastr.danger', 'You cannot remove this company. At least one company must exist')
    } else {
      if (!data.id || this.props.sessionStore.isBaseEdition) {
        this.companyDeleteMessage = baseEditionMsg
      } else {
        this.companyDeleteMessage = fullEditionMsg
      }
      this.setState({
        deleteCompanyData: { table, data, index },
        deleteCompanyShowConfirm: true
      })
    }
  }

  triggerOnChange () {
    this.props.onChange(this.state.companies)
  }

  componentDidMount () {
    this.setState({
      ready: true,
      companies: this.props.companies
    }, () => this.initialiseCompaniesTable())
  }

  render () {
    if (this.state.ready) {
      return (
        <React.Fragment>
          <div className='text-right my-2'>
            <mosaic-button
              type='button'
              icon='add'
              color='primary'
              onClick={this.addCompany}
              class='mr-1'>
              Add company
            </mosaic-button>
          </div>
          <mosaic-data-table id='tax-registration-companies-table' ref={this.tableRef} style={{ marginBottom: '55px' }}>
          </mosaic-data-table>
          {this.props.sessionStore.isFullEdition &&
            <CompanyModal header={this.state.companyEntryHeader} isOpen={this.state.companyEntryShowModal} toggle={this.toggleCompanyEntry}
              companyModalRef={this.companyModalRef}
              name={this.state.companyEntryData.data.name} sourceReference={this.state.companyEntryData.data.sourceReference}
              cancelFunction={this.cancelCompanyEntry} saveFunction={this.saveCompany} numberImportParts={this.state.companyEntryData.data.numberImportParts}
              numberGLElements={this.state.companyEntryData.data.numberGLElements} glElements={this.state.companyEntryData.data.GLElements}
              ImportParts={this.state.companyEntryData.data.ImportParts}
              hasJournal = {this.state.companyEntryData.data.hasJournal}
              isCompanyActive={this.state.companyEntryData.data.active || this.state.companyEntryData.data.isCompanyActive} Action={this.state.companyAction} />
          }

          {this.props.sessionStore.isBaseEdition &&
            <BaseCompanyModal header={this.state.companyEntryHeader} isOpen={this.state.companyEntryShowModal} toggle={this.toggleCompanyEntry}
              companyModalRef={this.companyModalRef}
              name={this.state.companyEntryData.data.name} sourceReference={this.state.companyEntryData.data.sourceReference}
              hasJournal = {this.state.companyEntryData.data.hasJournal}
              cancelFunction={this.cancelCompanyEntry} saveFunction={this.saveCompany}
              isCompanyActive={this.state.companyEntryData.data.active || this.state.companyEntryData.data.isCompanyActive}
              Action={this.state.companyAction} companyActionButtonName='Save' />
          }
          <ConfirmBox header='Confirm delete' togConfirm={this.state.deleteCompanyShowConfirm} toggleConfirm={this.toggleDeleteCompanyConfirm}
            message={this.companyDeleteMessage} rejectFunction={this.toggleDeleteCompanyCancel}
            acceptFunction={this.deleteCompanyConfirmed} />
        </React.Fragment>
      )
    } else {
      return (
        <mosaic-card class='rounded-0 border-0 shadow h-100'>
          <Placeholder />
        </mosaic-card>
      )
    }
  }
}

Companies.propTypes = {
  companies: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  sessionStore: PropTypes.instanceOf(SessionStore)
}

export { Companies }
